import { render, staticRenderFns } from "./taskDialog.vue?vue&type=template&id=7bf63729&"
import script from "./taskDialog.vue?vue&type=script&lang=js&"
export * from "./taskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports